
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { dashedVid } from '@/utils/index'
import VSwiper from '@/components/Swiper/index.vue'
import VeVideo from '@/components/VeVideo/index.vue'
import FSwiper from '@/components/Swiper/file.vue'
import WebPage from '@/components/Webpage/index.vue'
import '@/components/ProductInfo/index.scss'
@Component({
  components: {
    VSwiper,
    VeVideo,
    FSwiper,
    WebPage
  },
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private landingInfo!: any
  @Prop({default: () => {
    return []
  }}) private additionDcuList!: Array<any>
  
  /// data
  private data: Object = {}
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }

  private get headTitle(): any {
    if(this.landingInfo && this.landingInfo.customizedLp){
      let {custom} = this.landingInfo.activity
      return custom.textplain_013 || this.$t('app.show_info')
    }
    return this.$t('app.show_info')
  }

  private get description(): string {
    let {activity} = this.landingInfo
    return activity && activity.custom && activity.custom.textmultiline1585278641706 || ""
  }
  private get name(): string {
    let {activity} = this.landingInfo
    return activity && activity.base && activity.base.name || ""
  }

  private previewIndex: number = new Date().getTime()

  private get dashedTxid(): string {
    //   dashedVid
    let {sku} = this.landingInfo
    let txId = sku && sku.blockinfo && sku.blockinfo.txId || ""
    return dashedVid(txId)
  }

  private get productImages(): Array<any> {
    let {activity} = this.landingInfo
    let moreImages = (activity && activity.custom && activity.custom.moreimages) || []
    return moreImages.map((item: any) => {
        return item.filelocation
    })
  }
  private get productDescribe(): string {
    let {sku} = this.landingInfo
    return sku && sku.base && sku.base.description
  }
  private get parameters(): Array<any> {

    let {activity} = this.landingInfo
    return ((activity && activity.custom && activity.custom.otherlist1589268077752) || []).map((item: any) => {
      return {
        key: item.key || item.textplain1589268084992 || "",
        value: item.value || item.textmultiline1589268086882 || ""
      }
    })
  }

  private get moreVideos(): Array<any> {
    let {activity} = this.landingInfo
    let videos = (activity && activity.custom && activity.custom.morevideos) || (activity && activity.custom && activity.custom.morevedios) || []
    return videos
  }

  private get fileList(): Array<any> {
    let {activity} = this.landingInfo
    let videos = (activity && activity.custom && activity.custom.otherlist1589268342573) || []
    return videos
  }

  private get webpages(): Array<any> {
    let {activity} = this.landingInfo
    let videos = (activity && activity.custom && activity.custom.webpages) || (activity && activity.custom && activity.custom.otherlist1592898286244) || []
    return videos
  }
  
  private openTxRecord() {
      let {sku, explorerUrl} = this.landingInfo
      let txId = sku && sku.blockinfo && sku.blockinfo.txId || ""
      // txId && window.open(explorerUrl + "/transactions/" + txId)
      if(document.domain.endsWith(".cn")){
        this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      }else{
        txId && window.open(explorerUrl + "/transactions/" + txId)
      }
  }

  /// lifecycle
  created() {
    
  }
  
  mounted() {
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
